import SVG from "@Components/Icons/SVG";
export default class Exit extends SVG {
    path = [
        "M 50.0032 0 A 1.3699 1.3699 90 0 0 50 100 A 1.3699 1.3699 90 0 0 50 0 M 38 25 L 50 37 L 62 25 C 63 24 65 24 66 25 L 75 34 C 76 35 76 37 75 38 L 63 50 L 75 62 C 76 63 76 65 75 66 L 66 75 C 65 76 63 76 62 75 L 50 63 L 38 75 C 37 76 35 76 34 75 L 25 66 C 24 65 24 63 25 62 L 37 50 L 25 38 C 24 37 24 35 25 34 L 34 25 C 35 24 37 24 38 25",
    ];
    evenOdd = true;
}
